import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_MAIL_MESSAGES_READ } from '@/api/endpoints';
import { USER_UNSEEN_EVENTS_QUERY_KEY } from '@/api/queryKeys';
import { useRefreshProfiles } from '@/hooks/useRefreshProfiles';
import { ErrorMessage, logRequestError } from '@/utils/errors';

export const useMarkMailRead = () => {
  const queryClient = useQueryClient();
  const refreshProfiles = useRefreshProfiles();

  const { mutate: markRead } = useMutation({
    mutationFn: (messageId: string) =>
      apiClient.patch(API_MAIL_MESSAGES_READ, {
        messageIds: [Number(messageId)],
      }),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: USER_UNSEEN_EVENTS_QUERY_KEY });
      await refreshProfiles();
    },
    onError: (error) =>
      logRequestError(ErrorMessage.MarkMailMessagesRead, error),
  });

  return { markRead };
};
